export type TemplateSplit<
    VALUE extends string,
    DELIMITER extends string,
> = VALUE extends `${infer T}${DELIMITER}${infer REST}`
    ? [T, ...TemplateSplit<REST, DELIMITER>]
    : [VALUE];

// A counterpart to JavaScript's string.split function that allows to parse templates without losing the type info
// The caller needs to be careful about not letting the value of T contain an instance of the delimiter, otherwise the bindings will be wrong
export function splitTemplateLiteralType<
    T extends string,
    DELIMITER extends string,
>(value: T, delimiter: DELIMITER): TemplateSplit<T, DELIMITER> {
    return value.split(delimiter) as TemplateSplit<T, DELIMITER>;
}
